module.exports = __webpack_public_path__ + "static/media/mn.933606d5.svg";